export default "__VITE_ASSET__b8cd5363__"